/**
 * Safely opens an external link in a new tab.
 * Only allows http and https protocols.
 *
 * @returns true if the link was opened, false otherwise
 */
export function openSafeExternalLink(
  url?: string | null,
  target: '_blank' | '_self' = '_blank'
): boolean {
  if (!url) return false;

  try {
    const parsed = new URL(url);

    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return false;
    }

    window.open(parsed.href, target, 'noopener,noreferrer');
    return true;
  } catch {
    return false;
  }
}

export const buildUrlWithParams = (
  urlPath: string,
  queryParams?: Record<string, string>,
  pagination?: { page: number; pageSize: number }
) => {
  const [basePath, existingQuery] = urlPath.split('?');
  const params = new URLSearchParams(existingQuery ?? '');

  if (queryParams) {
    Object.entries(queryParams).forEach(([k, v]) => {
      params.set(k, v);
    });
  }

  if (pagination) {
    params.set('page', String(pagination.page));
    params.set('pageSize', String(pagination.pageSize));
  }

  // Canonalize ordering of query parameters for consistency
  const sortedParams = new URLSearchParams(
    Array.from(params.entries()).sort(([a], [b]) => a.localeCompare(b))
  );

  const qs = sortedParams.toString();
  return qs ? `${basePath}?${qs}` : basePath;
};
